import React from "react";
import PropTypes from "prop-types";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import EventLabel2 from "../../../components/EventLabel2/EventLabel2";
import LinkIcon from "@material-ui/icons/Link";
import InsertDriveFileTwoToneIcon from "@material-ui/icons/InsertDriveFileTwoTone";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`full-width-tabpanel-${index}`} aria-labelledby={`full-width-tab-${index}`} {...other}>
      {value === index && children}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#fff",
    width: "100%",
    borderRadius: "4px",
  },
}));

export default function SideViewTabs(props) {
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <AppBar
        position="static"
        style={{
          backgroundColor: "#fff",
          boxShadow: "none",
        }}
      >
        <Tabs value={value} onChange={handleChange} indicatorColor="primary" textColor="primary" variant="fullWidth" aria-label="full width tabs example">
          <Tab style={{ background: value == 0 ? "#fff" : "#ebebeb" }} label={<EventLabel2 name="Exhibitors" groupName="Exhibitor.Booth" />} {...a11yProps(0)} />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0} dir={theme.direction}>
        {props.chatView}
      </TabPanel>
    </div>
  );
}

export function SideViewTabs2(props) {
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const {
    notices = {
      video: false,
      chat: false,
    },
    template,
  } = props;

  return (
    <div className={classes.root}>
      <AppBar
        position="static"
        style={{
          backgroundColor: "#fff",
          boxShadow: "none",
        }}
      >
        <Tabs value={value} onChange={handleChange} indicatorColor="primary" textColor="primary" variant="fullWidth" aria-label="full width tabs example">
          <Tab
            style={{ fontFamily: template ? template.subtitle.fontFamily : undefined, background: value == 0 ? "#fff" : "#ebebeb" }}
            label={
              <div style={{ display: "inline-flex" }}>
                <InsertDriveFileTwoToneIcon style={{ fontSize: 18, marginRight: 10 }} />{" "}
                <span style={{ fontSize: 12 }}>
                  <EventLabel2 name="Files" groupName="Exhibitor.Booth" />
                </span>
              </div>
            }
            {...a11yProps(1)}
          />
          <Tab
            style={{ fontFamily: template ? template.subtitle.fontFamily : undefined, background: value == 1 ? "#fff" : "#ebebeb" }}
            label={
              <div style={{ display: "inline-flex" }}>
                <LinkIcon style={{ fontSize: 18, marginRight: 10 }} />{" "}
                <span style={{ fontSize: 12 }}>
                  <EventLabel2 name="LinkS" groupName="Exhibitor.Booth" />
                </span>
              </div>
            }
            {...a11yProps(2)}
          />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0} dir={theme.direction}>
        {props.fileView}
      </TabPanel>
      <TabPanel value={value} index={1} dir={theme.direction}>
        {props.linkView}
      </TabPanel>
    </div>
  );
}
